import React, { useState } from "react";
import { Alert } from "@material-ui/lab";
import { NavLink } from "react-router-dom";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import MaterialSwitch from "../../../styles/materialSwitch";
import DialogModal from "../../../elements/dialogModal/DialogModal";
import TwoFa from "../../../elements/twoFa/TwoFa";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { check2FA } from "../../../../utils/check2FA";
import getUserInfo from "../../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

const ClientConnectionsList = ({ connections, fetchConnections, notification, setNotification }) => {
  const { t } = useTranslation("clientsPage");
  const [error, setError] = useState({});
  const [open, setOpen] = useState(false);
  const [changeConnection, setChangeConnection] = useState({
    id: null
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put("/api/connections/" + changeConnection.id, changeConnection, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        fetchConnections();
        setOpen(false);
        setChangeConnection({id: null});
        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: t("details.connections.table.success")
        });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  if (!connections) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (connections.length === 0) {
    return <Alert severity="warning">{t("details.connections.table.emptyData")}</Alert>;
  }

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.connections.table.twoFa")}
        content={<TwoFa
          handleSubmit={handleSubmit}
          error={error}
        />}
      />
      <StyledScrollTable>
        <StyledTable
          width="920"
          size="14"
        >
          <StyledTableHead
            scroll="auto"
            col="6"
          >
            <div>
              {t("details.connections.table.project")}
            </div>
            <div>
              {t("details.connections.table.service")}
            </div>
            <div>
              UUID
            </div>
            <div>
              {t("details.connections.table.payment")}
            </div>
            <div>
              {t("details.connections.table.payout")}
            </div>
            <div>
              {t("details.connections.table.date")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {connections && connections.map((value, key) => (
              <StyledTableRow
                key={key}
                scroll="auto"
                col="6"
              >
                <StyledCol>
                  {value.project.name}
                </StyledCol>
                <StyledCol>
                  <NavLink to={`/services/${value.service.id}`}>
                    {getServiceNameWithNickname(value.service.name, value.service.nickname)}
                  </NavLink>
                </StyledCol>
                <StyledCol>
                  {value.id}
                </StyledCol>
                <StyledCol>
                  <MaterialSwitch
                    checked={value.enablePayment}
                    onChange={event => {
                      setChangeConnection({ ...changeConnection, id: value.id, enablePayment: event.target.checked });
                      setOpen(true);
                    }}
                    name={value.name}
                  />
                </StyledCol>
                <StyledCol>
                  <MaterialSwitch
                    checked={value.enablePayout}
                    onChange={event => {
                      setChangeConnection({ ...changeConnection, id: value.id, enablePayout: event.target.checked });
                      setOpen(true);
                    }}
                    name={value.name}
                  />
                </StyledCol>
                <StyledCol>
                  {TimestampToDateMoment(value.createDate)}
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};

export default ClientConnectionsList;